let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("6iJa4")).then(() => parcelRequire('fGqec'));